import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://ovwtkudueakmxedklmrq.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im92d3RrdWR1ZWFrbXhlZGtsbXJxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE4ODkwNzYsImV4cCI6MjA2NzQ2NTA3Nn0.3HJsh31vJM44SUFDcH3GHsQcrN5CKcyAhOO2FGa32Ks'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)